import { forwardRef, InputHTMLAttributes } from 'react'
import { FieldErrors } from 'react-hook-form'
import { cn } from '@/utils/classnames'

export interface ToggleProps extends InputHTMLAttributes<HTMLInputElement> {
  label: string
  labelSrOnly?: boolean
  errors?: FieldErrors
  'data-testid': string
}

const Toggle = forwardRef<HTMLInputElement, ToggleProps>(
  (
    {
      id,
      name,
      label,
      labelSrOnly,
      className,
      'data-testid': testId,
      defaultChecked,
      ...props
    },
    ref
  ) => {
    const checkboxClassNames = cn(
      'elm-toggle',
      { 'cursor-pointer': !props.disabled },
      'shrink-0',
      'dark:bg-cool-gray-500',
      'dark:before:bg-cool-gray-400',
      'dark:checked:bg-cool-gray-300',
      'dark:checked:before:bg-cool-gray-200'
    )

    return (
      <div
        className={cn('flex items-center', className)}
        data-testid={`${testId}-wrapper`}
      >
        <label
          className={cn('elm-label flex items-center gap-0.5', {
            'cursor-pointer': !props.disabled
          })}
          htmlFor={id}
          id={`${id}-label`}
          data-testid={`${testId}-label`}
        >
          <input
            type="checkbox"
            role="switch"
            id={id}
            name={name}
            className={checkboxClassNames}
            defaultChecked={defaultChecked}
            data-testid={testId}
            {...props}
            ref={ref}
          />
          <span
            data-testid={`${testId}-text`}
            className={cn({ 'sr-only': labelSrOnly })}
          >
            {label}
          </span>
        </label>
      </div>
    )
  }
)

Toggle.displayName = 'Toggle'

export default Toggle
